export default __webpack_public_path__ + "static/media/grayman1.2d4d4e9c.jpeg";